import { ThirdPartyAdapter } from '../thirdparty-adapter/index.esm.js';
import { appendQueryObject } from '../url-util/index.esm.js';

/**
 * @deprecated This file is deprecated and should no longer be used or modified.
 * Please use shared UI adapters instead.
 */
const mapBoxApiAccessToken = (typeof window !== 'undefined' && typeof window.Cypress !== 'undefined' ? window.Cypress.env('MAPBOX_API_ACCESS_TOKEN') : "pk.eyJ1IjoiZXhwZWRpYS1nZW8iLCJhIjoiY2s3NTc2aTExMDJwZDNmbnN1cDdvcmRzNSJ9.Grb_k2_kcl7NXEu6paSB1w") || '';
/**
 * @deprecated
 */
class MapboxAdapter extends ThirdPartyAdapter {
  language;
  static instances = {};
  constructor(locale, apiKey) {
    super(locale);
    [this.language, this.locale] = locale.split('_');
    this.category = 'MAPBOX';
    this.sourceName = 'mapbox';
    this.type = 'address';
    this.apiKey = apiKey || mapBoxApiAccessToken;
  }
  static getInstance(locale, apiKey) {
    const thisLocale = locale || 'en_US';
    const thisApiKey = apiKey || mapBoxApiAccessToken;
    if (!(thisLocale in this.instances)) {
      this.instances[thisLocale] = new MapboxAdapter(thisLocale, thisApiKey);
    }
    return this.instances[thisLocale];
  }
  getGeocodingUrl(queryStr, param) {
    const endpoint = `https://api.mapbox.com/geocoding/v5/mapbox.places/${queryStr}.json?`;
    return appendQueryObject(endpoint, param);
  }
  fetchFromMapbox(queryStr) {
    const endpoint = this.getGeocodingUrl(queryStr, {
      autocomplete: true,
      language: this.language,
      types: this.type,
      fuzzyMatch: true,
      access_token: this.apiKey
    });
    return fetch(endpoint).then(resp => resp.json());
  }
  fetchResults(essResponse) {
    const toEssResponse = results => ({
      q: essResponse.q,
      rc: essResponse.rc,
      rid: essResponse.rid,
      sr: results
    });
    return new Promise(resolve => {
      this.fetchFromMapbox(essResponse.q).then(respBody => respBody?.features === undefined ? [] : respBody.features).then(predictions => predictions.length === 0 ? resolve(essResponse) : resolve(toEssResponse(this.handleResponse(predictions)))).catch(() => {
        resolve(essResponse);
      });
    });
  }
  handleResponse(predictions) {
    const results = [];
    predictions.forEach((prediction, index) => {
      const placeId = prediction.id.split('.')[1];
      results.push(this.toEssResult(prediction.place_name, placeId, index));
    });
    return results;
  }
}
export { MapboxAdapter };